import styled from '@emotion/styled';
import { RegistryItem } from '../context/RegistryContext';
import { useMemo } from 'react';
import FixedNextImage from './NextImage/FixedNextImage';

const RegistryPreviewItemSize = 175;

const RegistryPreviewContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
`;

const RegistryItemImage = styled('div')`
  width: ${RegistryPreviewItemSize}px;
  height: ${RegistryPreviewItemSize}px;
  border-radius: 8px;
  overflow: hidden;
`;

interface RegistryPreviewProps {
  registryItems: RegistryItem[];
  numberOfItems?: number;
}

const RegistryPreview = ({
  registryItems,
  numberOfItems = 6,
}: RegistryPreviewProps) => {
  const filteredItems = useMemo(
    () => registryItems.slice(0, numberOfItems),
    [registryItems, numberOfItems]
  );

  return (
    !!filteredItems.length && (
      <RegistryPreviewContainer>
        {filteredItems.map((item) => (
          <RegistryItemImage key={item.name}>
            <FixedNextImage
              src={item.imageUrl}
              alt={item.name}
              width={RegistryPreviewItemSize}
              height={RegistryPreviewItemSize}
              skipUrlProcessing
              dataTestId="RegistryItemImage"
            />
          </RegistryItemImage>
        ))}
      </RegistryPreviewContainer>
    )
  );
};

export default RegistryPreview;
